<app-dialog-header [title]="'EVENT.ATTENDANCE.EVENT_ATTENDANCE'" (onClick)="dialogRef.close(null)"></app-dialog-header>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="start" class="p-24">
    <app-module-participant-attendance-list
        [moduleId]="moduleId"
        [participantId]="participantId"
        [participantAttendances]="participantAttendances"
    ></app-module-participant-attendance-list>
</div>
